export const TEXT_TYPES = {
  HEADER: 'header',
  PANEL: 'panel',
  SECTION: 'section',
};
